<template>
    <div class="content">
        <div class="row">
            <div class="col-lg-4 mb-2 mb-lg-0">
                <h3 class="text-black">
                    <span class="text-heading">OUR VISION</span>
                    <img src="../../assets/vision-icon.svg" class="img-fluid icon-image" alt="Our Vision">
                    <h6>
                        To be the No 1 real estate development company in Sub- Sahara Africa and the whole World.
                    </h6>
                </h3>
            </div>
            <div class="col-lg-4 mb-2 mb-lg-0">
                <h3 class="text-black">
                    <span class="text-heading">OUR MISSION</span>
                    <img src="../../assets/mission-icon.svg" class="img-fluid icon-image" alt="Our Mission">
                    <h6>
                        To bring your real estate dream, desire and expectation into reality with our total commitment to affordable housing through our multi-channeled services.
                    </h6>
                </h3>
            </div>
            <div class="col-lg-4 mb-2 mb-lg-0">
                <h3 class="text-black">
                    <span class="text-heading">OUR CORE VALUE</span>
                    <img src="../../assets/value-icon.svg" class="img-fluid icon-image" alt="Our Core Value">
                    <h6>
                        Integrity | Trust | Timely Delivery
                    </h6>
                </h3>
            </div>
        </div>
        <hr class="divider" />
        <div class="row">
            <div class="col-lg-4 mb-2 mb-lg-0 row mx-0 align-items-center">
                <div class="col-4 mb-2 mb-lg-0 d-flex justify-content-end justify-content-lg-start">
                    <img src="../../assets/property-dev-icon.png" alt="Property Development">
                </div>
                <div class="col-8">
                    <h6 class="font-bold">PROPERTY DEVELOPMENT</h6>
                    <span>
                        We bring to bear our experience and expertise in developing luxury and state-of-the-art property for sale and for rent.
                    </span>
                </div>
            </div>
            <div class="col-lg-4 mb-2 mb-lg-0 row mx-0 align-items-center">
                <div class="col-4 mb-2 mb-lg-0 d-flex justify-content-end justify-content-lg-start">
                    <img src="../../assets/land-icon.svg" alt="LAND/PROPERTY SALE">
                </div>
                <div class="col-8">
                    <h6 class="font-bold">LAND/PROPERTY SALE</h6>
                    <span>
                        We specialize in the sale of lands and houses. We also offer flexible payment plans and incentives to make acquiring your property easier.
                    </span>
                </div>
            </div>
            <div class="col-lg-4 mb-2 mb-lg-0 row mx-0 align-items-center">
                <div class="col-4 mb-2 mb-lg-0 d-flex justify-content-end justify-content-lg-start">
                    <img src="../../assets/advisory-icon.svg" alt="Real Estate Advisory">
                </div>
                <div class="col-8">
                    <h6 class="font-bold">REAL ESTATE ADVISORY</h6>
                    <span>
                        We draw from our vast and deep knowledge of the Real Estate industry to give our clients the guidance and advisory services they require.
                    </span>
                </div>
            </div>
        </div>
        <UserList :executives="executives" />
    </div>
</template>

<script>
import UserList from '../common/UserList'

export default {
    name: "About",
    components: {
        UserList,
    },
    computed: {
        executives() {
            return this.$store.state.executives
        },
    },
}
</script>

<style scoped>
.content {
    text-align: left;
    margin: 50px 0;
}
.text-heading {
    font-weight: 600;
}
.icon-image {
    position: relative;
    bottom: 5px;
    left: 10px;
}
hr.divider {
    overflow: visible; /* For IE */
    padding: 0;
    border: none;
    border-top: 2px solid #ece5ec;
    color: #ece5ec;
    text-align: center;
    margin: 50px 0;
}
hr.divider:after {
    content: "WHAT WE DO";
    display: inline-block;
    position: relative;
    top: -0.7em;
    color: #6E2169;
    font-size: 1.5em;
    padding: 0 0.25em;
    background: #F9F9F9;
    padding: 0 5px;
}
</style>